import { LICENSE_STATUS_CONFIG } from "../../lib/constants.ts";
import { Tooltip } from "./Tooltip.tsx";

const STATUS_DESCRIPTIONS: Record<string, string> = {
  not_started: "No work has begun on this item",
  preparing: "Application is being prepared",
  submitted: "Submitted to the authority",
  under_review: "Authority is reviewing the application",
  additional_info_requested: "The authority needs more information",
  approved: "License has been granted",
  rejected: "Application was rejected",
  expired: "License has expired and needs renewal",
  blocked: "Waiting on prerequisite licenses",
  unrecognized: "Document type not recognized — no fields to extract. You can delete this or ignore it.",
};

interface StatusPillProps {
  status: keyof typeof LICENSE_STATUS_CONFIG;
}

export function StatusPill({ status }: StatusPillProps) {
  const config = LICENSE_STATUS_CONFIG[status] ?? LICENSE_STATUS_CONFIG.not_started;
  const description = STATUS_DESCRIPTIONS[status];
  const pill = (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-[13px] font-medium ${config.bg} ${config.text}`}>
      {config.label}
    </span>
  );
  return description ? <Tooltip text={description}>{pill}</Tooltip> : pill;
}
